/** Domain fragments for verified Indian news publishers (aligned with backend allow-list). */
export const VERIFIED_SOURCE_FRAGMENTS = [
  'economictimes',
  'livemint',
  'ptinews',
  'pti',
  'moneycontrol',
  'business-standard',
  'thehindu',
  'hindustantimes',
  'indiatimes',
  'dnaindia',
  'financialexpress',
  'ndtv',
  'zeenews',
  'timesofindia',
  'indianexpress',
  'firstpost',
  'outlookindia',
  'deccanherald',
  'tribuneindia',
  'newindianexpress',
  'livelaw',
  'barandbench',
  'scconline',
  'lawstreetindia',
  'reuters',
  'bbc',
];

let customSourceFragments = [];

export function normalizeDomain(domain) {
  return (domain || '').toLowerCase().replace(/^www\./, '').trim();
}

export function setCustomSourceFragments(sources = []) {
  customSourceFragments = Array.isArray(sources)
    ? sources.map(normalizeDomain).filter(Boolean)
    : [];
}

export function isVerifiedSource(domain) {
  const d = normalizeDomain(domain);
  if (!d) return false;
  return [...VERIFIED_SOURCE_FRAGMENTS, ...customSourceFragments].some(fragment => d.includes(fragment));
}

export function getSourceTrust(domain) {
  return isVerifiedSource(domain)
    ? { level: 'verified', label: 'Verified' }
    : { level: 'unknown', label: 'Unverified' };
}

export function formatSourceLabel(domain) {
  const d = normalizeDomain(domain);
  if (!d) return 'Source';
  const base = d.split('.')[0];
  if (base.includes('economictimes')) return 'Economic Times';
  if (base.includes('livemint')) return 'Livemint';
  if (d.includes('pti')) return 'PTI';
  return d;
}
